import { render, staticRenderFns } from "./Arrow2.vue?vue&type=template&id=7aa03b7b&"
import script from "./Arrow2.vue?vue&type=script&lang=ts&"
export * from "./Arrow2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports